<template>
  <div>
    <div class="mb-3">
      <label for="">{{ 'Header' | translate }}</label>
      <input
        class="form-control"
        type="text"
        v-model="block.header"
        :placeholder="$t('Header')"
        maxlength="200"
      />
    </div>
    <hr />
    <div class="mb-3">
      <div class="form-check form-switch mt-2">
        <input
          type="checkbox"
          class="form-check-input"
          v-model="doNotDisplayPrices"
          value="1"
          :id="`do-not-display-prices-${block.id}`"
        />
        <label class="form-check-label" :for="`do-not-display-prices-${block.id}`">
          <small>{{ 'Do not display prices' | translate }}</small>
        </label>
      </div>
    </div>
    <div class="mb-3">
      <div class="form-check form-switch mt-2">
        <input
          type="checkbox"
          class="form-check-input"
          v-model="displayAsSlider"
          value="1"
          :id="`display-as-slider-${block.id}`"
        />
        <label class="form-check-label" :for="`display-as-slider-${block.id}`">
          <small>{{ 'Display as slider' | translate }}</small>
        </label>
      </div>
    </div>
    <div class="mb-3" v-if="displayAsSlider">
      <div class="form-check form-switch mt-2">
        <input
          type="checkbox"
          class="form-check-input"
          v-model="sliderAutoplay"
          value="1"
          :id="`slider-autoplay-${block.id}`"
        />
        <label class="form-check-label" :for="`slider-autoplay-${block.id}`">
          <small>{{ 'Slider autoplay' | translate }}</small>
        </label>
      </div>
    </div>
    <div class="mb-3">
      <div class="">
        <div class="form-check form-switch mt-2">
          <input
            type="checkbox"
            class="form-check-input"
            v-model="moreButton"
            value="1"
            :id="`display-more-${block.id}`"
          />
          <label class="form-check-label" :for="`display-more-${block.id}`">
            <small>{{'Show' | translate}}</small> <small class="text-lowercase">{{ 'More button' | translate }}</small>
          </label>
        </div>
      </div>
      <div class="row" v-if="moreButton">
        <div class="col-6">
          <label for="more-button-text" class="small text-capitalize">
            {{ 'text' | translate }}
          </label>
          <input
            v-model="moreButtonText"
            type="text"
            class="form-control"
            id="more-button-text"
          />
        </div>

        <div class="col-6">
          <label for="" class="small text-capitalize">
            {{ 'color' | translate }}
          </label>
          <select name="" id="" v-model="moreButtonStyle" class="form-control">
            <option value="primary">{{ 'Blue' | translate }}</option>
            <option value="outline-primary">
              {{ 'Blue' | translate }} ({{ 'outline' | translate }})
            </option>
            <option value="secondary">{{ 'Grey' | translate }}</option>
            <option value="outline-secondary">
              {{ 'Grey' | translate }} ({{ 'outline' | translate }})
            </option>
            <option value="info">{{ 'Cyan' | translate }}</option>
            <option value="outline-info">
              {{ 'Cyan' | translate }} ({{ 'outline' | translate }})
            </option>
            <option value="success">{{ 'Green' | translate }}</option>
            <option value="outline-success">
              {{ 'Green' | translate }} ({{ 'outline' | translate }})
            </option>
            <option value="warning">{{ 'Yellow' | translate }}</option>
            <option value="outline-warning">
              {{ 'Yellow' | translate }} ({{ 'outline' | translate }})
            </option>
            <option value="danger">{{ 'Red' | translate }}</option>
            <option value="outline-danger">
              {{ 'Red' | translate }} ({{ 'outline' | translate }})
            </option>
            <option value="light">{{ 'Light' | translate }}</option>
            <option value="outline-light">
              {{ 'Light' | translate }} ({{ 'outline' | translate }})
            </option>
            <option value="dark">{{ 'Dark' | translate }}</option>
            <option value="outline-dark">
              {{ 'Dark' | translate }} ({{ 'outline' | translate }})
            </option>
            <option value="indigo">{{ 'Indigo' | translate }}</option>
            <option value="outline-indigo">
              {{ 'Indigo' | translate }} ({{ 'outline' | translate }})
            </option>
            <option value="pink">{{ 'Pink' | translate }}</option>
            <option value="outline-pink">
              {{ 'Pink' | translate }} ({{ 'outline' | translate }})
            </option>
            <option value="purple">{{ 'Purple' | translate }}</option>
            <option value="outline-purple">
              {{ 'Purple' | translate }} ({{ 'outline' | translate }})
            </option>
            <option value="teal">{{ 'Teal' | translate }}</option>
            <option value="outline-teal">
              {{ 'Teal' | translate }} ({{ 'outline' | translate }})
            </option>
            <option value="link">{{ 'Link' | translate }}</option>
          </select>
        </div>
      </div>
    </div>

    <div class="mb-3">
      <div class="">
        <div class="form-check form-switch mt-2">
          <input
            type="checkbox"
            class="form-check-input"
            v-model="buyButton"
            value="1"
            :id="`display-buy-${block.id}`"
          />
          <label class="form-check-label" :for="`display-buy-${block.id}`">
            <small>{{'Show' | translate}}</small> <small class="text-lowercase">{{ 'Buy button' | translate }}</small>
          </label>
        </div>
      </div>
      <div class="row" v-if="buyButton">
        <div class="col-6">
          <label for="buy-button-text" class="small text-capitalize">
            {{ 'text' | translate }}
          </label>
          <input
            v-model="buyButtonText"
            type="text"
            class="form-control"
            id="buy-button-text"
          />
        </div>

        <div class="col-6">
          <label for="" class="small text-capitalize">
            {{ 'color' | translate }}
          </label>
          <select name="" id="" v-model="buyButtonStyle" class="form-control">
            <option value="primary">{{ 'Blue' | translate }}</option>
            <option value="outline-primary">
              {{ 'Blue' | translate }} ({{ 'outline' | translate }})
            </option>
            <option value="secondary">{{ 'Grey' | translate }}</option>
            <option value="outline-secondary">
              {{ 'Grey' | translate }} ({{ 'outline' | translate }})
            </option>
            <option value="info">{{ 'Cyan' | translate }}</option>
            <option value="outline-info">
              {{ 'Cyan' | translate }} ({{ 'outline' | translate }})
            </option>
            <option value="success">{{ 'Green' | translate }}</option>
            <option value="outline-success">
              {{ 'Green' | translate }} ({{ 'outline' | translate }})
            </option>
            <option value="warning">{{ 'Yellow' | translate }}</option>
            <option value="outline-warning">
              {{ 'Yellow' | translate }} ({{ 'outline' | translate }})
            </option>
            <option value="danger">{{ 'Red' | translate }}</option>
            <option value="outline-danger">
              {{ 'Red' | translate }} ({{ 'outline' | translate }})
            </option>
            <option value="light">{{ 'Light' | translate }}</option>
            <option value="outline-light">
              {{ 'Light' | translate }} ({{ 'outline' | translate }})
            </option>
            <option value="dark">{{ 'Dark' | translate }}</option>
            <option value="outline-dark">
              {{ 'Dark' | translate }} ({{ 'outline' | translate }})
            </option>
            <option value="indigo">{{ 'Indigo' | translate }}</option>
            <option value="outline-indigo">
              {{ 'Indigo' | translate }} ({{ 'outline' | translate }})
            </option>
            <option value="pink">{{ 'Pink' | translate }}</option>
            <option value="outline-pink">
              {{ 'Pink' | translate }} ({{ 'outline' | translate }})
            </option>
            <option value="purple">{{ 'Purple' | translate }}</option>
            <option value="outline-purple">
              {{ 'Purple' | translate }} ({{ 'outline' | translate }})
            </option>
            <option value="teal">{{ 'Teal' | translate }}</option>
            <option value="outline-teal">
              {{ 'Teal' | translate }} ({{ 'outline' | translate }})
            </option>
            <option value="link">{{ 'Link' | translate }}</option>
          </select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
export default {
  props: ['block'],
  methods: {},
  computed: {
    doNotDisplayPrices: {
      get() {
        return _.get(this, 'block.settings.do_not_display_prices')
      },
      set(value) {
        let settings = _.get(this, 'block.settings', {})
        this.$set(this.block, 'settings', {
          ...settings,
          do_not_display_prices: value,
        })
      },
    },
    moreButton: {
      get() {
        return _.get(this, 'block.settings.display_more_button')
      },
      set(value) {
        let settings = _.get(this, 'block.settings', {})
        this.$set(this.block, 'settings', {
          ...settings,
          display_more_button: value,
        })
      },
    },
    buyButton: {
      get() {
        return _.get(this, 'block.settings.display_buy_button')
      },
      set(value) {
        let settings = _.get(this, 'block.settings', {})
        this.$set(this.block, 'settings', {
          ...settings,
          display_buy_button: value,
        })
      },
    },
    moreButtonText: {
      get() {
        return _.get(this, 'block.settings.more_button_text')
      },
      set(value) {
        let settings = _.get(this, 'block.settings', {})
        this.$set(this.block, 'settings', {
          ...settings,
          more_button_text: value,
        })
      },
    },
    buyButtonText: {
      get() {
        return _.get(this, 'block.settings.buy_button_text')
      },
      set(value) {
        let settings = _.get(this, 'block.settings', {})
        this.$set(this.block, 'settings', {
          ...settings,
          buy_button_text: value,
        })
      },
    },
    moreButtonStyle: {
      get() {
        return _.get(this, 'block.settings.more_button_style')
      },
      set(value) {
        let settings = _.get(this, 'block.settings', {})
        this.$set(this.block, 'settings', {
          ...settings,
          more_button_style: value,
        })
      },
    },
    buyButtonStyle: {
      get() {
        return _.get(this, 'block.settings.buy_button_style')
      },
      set(value) {
        let settings = _.get(this, 'block.settings', {})
        this.$set(this.block, 'settings', {
          ...settings,
          buy_button_style: value,
        })
      },
    },
    displayAsSlider: {
      get() {
        return _.get(this, 'block.settings.display_as_slider')
      },
      set(value) {
        let settings = _.get(this, 'block.settings', {})
        this.$set(this.block, 'settings', {
          ...settings,
          display_as_slider: value,
        })
      },
    },
    sliderAutoplay: {
      get() {
        return _.get(this, 'block.settings.slider_autoplay')
      },
      set(value) {
        let settings = _.get(this, 'block.settings', {})
        this.$set(this.block, 'settings', {
          ...settings,
          slider_autoplay: value,
        })
      },
    },
  },
}
</script>
